import { Strategy } from '../types/mission';

export const STRATEGIES: Record<'A' | 'B' | 'C', Strategy> = {
  A: { letter: 'A', label: 'AOI_aggressive',   planes: 12, spp: 5, alt: 500, inc: 97.8, sw: 12, gsd: 5, rev: 14 },
  B: { letter: 'B', label: 'AOI_balanced_v2',  planes: 8,  spp: 4, alt: 540, inc: 97.6, sw: 12, gsd: 5, rev: 24 },
  C: { letter: 'C', label: 'AOI_lean',         planes: 5,  spp: 4, alt: 580, inc: 97.4, sw: 18, gsd: 8, rev: 42 },
};
